import { useEffect, useState } from "react";
import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import PublicHome from "./PublicHome";
import DashboardHome from "./DashboardHome";

function Home() {
  const [checkingAuth, setCheckingAuth] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user);
      setCheckingAuth(false);
    });

    return () => unsubscribe();
  }, []);

  if (checkingAuth) {
    return (
      <div style={loadingStyle}>
        Loading MyBuildID...
      </div>
    );
  }

  return isLoggedIn ? <DashboardHome /> : <PublicHome />;
}

const loadingStyle = {
  backgroundColor: "#111",
  color: "white",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "Arial",
};

export default Home;